import { empresasPlataforma, type EmpresaPlataforma } from './empresas';

export function getEmpresaById(id: string): EmpresaPlataforma | undefined {
  return empresasPlataforma.find(e => e.id === id);
}

export function updateEmpresaStatus(id: string, status: EmpresaPlataforma['status']): boolean {
  const empresa = empresasPlataforma.find(e => e.id === id);
  if (!empresa) return false;
  empresa.status = status;
  return true;
}

export function updateEmpresa(id: string, data: Partial<EmpresaPlataforma>): boolean {
  const empresa = empresasPlataforma.find(e => e.id === id);
  if (!empresa) return false;
  Object.assign(empresa, data);
  return true;
}

export function getEmpresasByStatus(status?: EmpresaPlataforma['status'] | 'todos'): EmpresaPlataforma[] {
  if (!status || status === 'todos') return [...empresasPlataforma];
  return empresasPlataforma.filter(e => e.status === status);
}

export function getEmpresasByPlano(plano?: string): EmpresaPlataforma[] {
  if (!plano || plano === 'todos') return [...empresasPlataforma];
  return empresasPlataforma.filter(e => e.plano === plano);
}

export function getEmpresasBySegmento(segmento?: string): EmpresaPlataforma[] {
  if (!segmento || segmento === 'todos') return [...empresasPlataforma];
  return empresasPlataforma.filter(e => e.segmento.toLowerCase().includes(segmento.toLowerCase()));
}

export function getStatusColor(status: EmpresaPlataforma['status']): string {
  switch (status) {
    case 'ativa': return 'bg-emerald-100 text-emerald-700';
    case 'pendente': return 'bg-amber-100 text-amber-700';
    case 'suspensa': return 'bg-orange-100 text-orange-700';
    case 'inativa': return 'bg-gray-100 text-gray-600';
    default: return 'bg-gray-100 text-gray-600';
  }
}

export function getStatusLabel(status: EmpresaPlataforma['status']): string {
  switch (status) {
    case 'ativa': return 'Ativa';
    case 'pendente': return 'Pendente';
    case 'suspensa': return 'Suspensa';
    case 'inativa': return 'Inativa';
    default: return status;
  }
}

export function getPlanoLabel(plano: string): string {
  switch (plano) {
    case 'basico': return 'Básico';
    case 'profissional': return 'Profissional';
    case 'enterprise': return 'Enterprise';
    default: return plano;
  }
}